// Style bubble assets
import ElegantSTD from 'assets/images/invitations/filter-bubbles/styles/std/elegant.webp';
import ElegantSTDV2 from 'assets/images/invitations/filter-bubbles/styles/std/elegant_v2.webp';
import MinimalistSTD from 'assets/images/invitations/filter-bubbles/styles/std/minimalist.webp';
import MinimalistSTDV2 from 'assets/images/invitations/filter-bubbles/styles/std/minimalist_v2.webp';
import FloralSTD from 'assets/images/invitations/filter-bubbles/styles/std/floral.webp';
import FloralSTDV2 from 'assets/images/invitations/filter-bubbles/styles/std/floral_v2.webp';
import TypographySTD from 'assets/images/invitations/filter-bubbles/styles/std/typography.webp';
import TypographySTDV2 from 'assets/images/invitations/filter-bubbles/styles/std/typography_v2.webp';
import MonogramSTD from 'assets/images/invitations/filter-bubbles/styles/std/monogram.webp';
import MonogramSTDV2 from 'assets/images/invitations/filter-bubbles/styles/std/monogram_v2.webp';
import RusticSTD from 'assets/images/invitations/filter-bubbles/styles/std/rustic.webp';
import RusticSTDV2 from 'assets/images/invitations/filter-bubbles/styles/std/rustic_v2.webp';
import GreenerySTD from 'assets/images/invitations/filter-bubbles/styles/std/greenery.webp';
import GreenerySTDV2 from 'assets/images/invitations/filter-bubbles/styles/std/greenery_v2.webp';
import VintageSTD from 'assets/images/invitations/filter-bubbles/styles/std/vintage.webp';
import VintageSTDV2 from 'assets/images/invitations/filter-bubbles/styles/std/vintage_v2.webp';

import ElegantINV from 'assets/images/invitations/filter-bubbles/styles/inv/elegant.webp';
import ElegantINVV2 from 'assets/images/invitations/filter-bubbles/styles/inv/elegant_v2.webp';
import MinimalistINV from 'assets/images/invitations/filter-bubbles/styles/inv/minimalist.webp';
import MinimalistINVV2 from 'assets/images/invitations/filter-bubbles/styles/inv/minimalist_v2.webp';
import FloralINV from 'assets/images/invitations/filter-bubbles/styles/inv/floral.webp';
import FloralINVV2 from 'assets/images/invitations/filter-bubbles/styles/inv/floral_v2.webp';
import TypographyINV from 'assets/images/invitations/filter-bubbles/styles/inv/typography.webp';
import TypographyINVV2 from 'assets/images/invitations/filter-bubbles/styles/inv/typography_v2.webp';
import MonogramINV from 'assets/images/invitations/filter-bubbles/styles/inv/monogram.webp';
import MonogramINVV2 from 'assets/images/invitations/filter-bubbles/styles/inv/monogram_v2.webp';
import RusticINV from 'assets/images/invitations/filter-bubbles/styles/inv/rustic.webp';
import RusticINVV2 from 'assets/images/invitations/filter-bubbles/styles/inv/rustic_v2.webp';
import GreeneryINV from 'assets/images/invitations/filter-bubbles/styles/inv/greenery.webp';
import GreeneryINVV2 from 'assets/images/invitations/filter-bubbles/styles/inv/greenery_v2.webp';
import VintageINV from 'assets/images/invitations/filter-bubbles/styles/inv/vintage.webp';
import VintageINVV2 from 'assets/images/invitations/filter-bubbles/styles/inv/vintage_v2.webp';

import { CARD_TYPE_MAP, LeadCardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import { FilterBubbleItem } from './types';

const STD_URL = '/wedding-planning/save-the-date/shop';
const INV_URL = '/wedding-planning/invitations/shop';

// NOTE: Values under "motifs" and "seo_colors" must be uppercase for the corresponding menu item to be selected.

export const STYLE_FILTER_BUBBLES: { [key in LeadCardType]?: Array<FilterBubbleItem> } = {
  [CARD_TYPE_MAP.std]: [
    {
      label: 'Elegant',
      image: ElegantSTD,
      imageV2: ElegantSTDV2,
      href: `${STD_URL}/elegant_formal`,
      filters: { motifs: ['ELEGANT_FORMAL'] },
    },
    {
      label: 'Minimalist',
      image: MinimalistSTD,
      imageV2: MinimalistSTDV2,
      href: `${STD_URL}/simple_minimalist`,
      filters: { motifs: ['SIMPLE_MINIMALIST'] },
    },
    {
      label: 'Floral',
      image: FloralSTD,
      imageV2: FloralSTDV2,
      href: `${STD_URL}/floral`,
      filters: { motifs: ['FLORAL'] },
    },
    {
      label: 'Typography',
      image: TypographySTD,
      imageV2: TypographySTDV2,
      href: `${STD_URL}/typography`,
      filters: { motifs: ['TYPOGRAPHY'] },
    },
    {
      label: 'Monogram',
      image: MonogramSTD,
      imageV2: MonogramSTDV2,
      href: `${STD_URL}/monogram`,
      filters: { motifs: ['MONOGRAM'] },
    },
    {
      label: 'Rustic',
      image: RusticSTD,
      imageV2: RusticSTDV2,
      href: `${STD_URL}/rustic`,
      filters: { motifs: ['RUSTIC'] },
    },
    {
      label: 'Greenery',
      image: GreenerySTD,
      imageV2: GreenerySTDV2,
      href: `${STD_URL}/greenery`,
      filters: { motifs: ['GREENERY'] },
    },
    {
      label: 'Vintage',
      image: VintageSTD,
      imageV2: VintageSTDV2,
      href: `${STD_URL}/vintage_retro`,
      filters: { motifs: ['VINTAGE_RETRO'] },
    },
  ],
  [CARD_TYPE_MAP.invitation]: [
    {
      label: 'Elegant',
      image: ElegantINV,
      imageV2: ElegantINVV2,
      href: `${INV_URL}/elegant_formal`,
      filters: { motifs: ['ELEGANT_FORMAL'] },
    },
    {
      label: 'Minimalist',
      image: MinimalistINV,
      imageV2: MinimalistINVV2,
      href: `${INV_URL}/simple_minimalist`,
      filters: { motifs: ['SIMPLE_MINIMALIST'] },
    },
    {
      label: 'Floral',
      image: FloralINV,
      imageV2: FloralINVV2,
      href: `${INV_URL}/floral`,
      filters: { motifs: ['FLORAL'] },
    },
    {
      label: 'Typography',
      image: TypographyINV,
      imageV2: TypographyINVV2,
      href: `${INV_URL}/typography`,
      filters: { motifs: ['TYPOGRAPHY'] },
    },
    {
      label: 'Monogram',
      image: MonogramINV,
      imageV2: MonogramINVV2,
      href: `${INV_URL}/monogram`,
      filters: { motifs: ['MONOGRAM'] },
    },
    {
      label: 'Rustic',
      image: RusticINV,
      imageV2: RusticINVV2,
      href: `${INV_URL}/rustic`,
      filters: { motifs: ['RUSTIC'] },
    },
    {
      label: 'Greenery',
      image: GreeneryINV,
      imageV2: GreeneryINVV2,
      href: `${INV_URL}/greenery`,
      filters: { motifs: ['GREENERY'] },
    },
    {
      label: 'Vintage',
      image: VintageINV,
      imageV2: VintageINVV2,
      href: `${INV_URL}/vintage_retro`,
      filters: { motifs: ['VINTAGE_RETRO'] },
    },
  ],
};
